import React, { useState } from "react";
import { api } from "../api/client";

export const RegisterPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [info, setInfo] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setInfo(null);
    setLoading(true);
    try {
      const res = await api.post("/auth/register", { email, password });
      setInfo(res.data.message || "Registrierung erfolgreich. Bitte E-Mail bestätigen.");
    } catch (err: any) {
      setError(err?.response?.data?.error || "Registrierung fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-auth">
      <h1>Registrieren</h1>
      <form onSubmit={onSubmit}>
        <label>
          E-Mail
          <input
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <label>
          Passwort (min. 6 Zeichen)
          <input
            type="password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        {info && <p className="info">{info}</p>}
        {error && <p className="error">{error}</p>}
        <button type="submit" disabled={loading}>
          {loading ? "Registriere..." : "Registrieren"}
        </button>
      </form>
    </div>
  );
};
